/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react'
import { Helmet } from 'react-helmet'
import '../style/mypoadcast.css'

const MyPoadcast = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name='description' content='Umang Ratani business consultancy resources offer expert insights and tools to optimize your business growth and management strategies effectively.' />
                <title>Umang Ratani: Expert Business Consultancy Resources</title>
            </Helmet>
            <section id='bgServeNewV'>
                <div className="container" style={{ textAlign: 'center' }} >
                    <h3 id='animath5' style={{ color: "white", paddingTop: "125px", paddingBottom: '175px' }} className="block-sub__title">Poadcast Resources</h3>
                </div>
            </section>
            <div className='container' style={{ marginTop: "50px" }}>
                <div className='row' style={{ textAlignLast: 'center' }}>
                    <div className='col-sm'>
                        <iframe src="https://open.spotify.com/embed/episode/20zwVurlHU3pUev5LOWArX?utm_source=generator&theme=0" height={'400px'} frameborder="0" ></iframe>
                    </div>
                    <div className='col-sm'>
                        <iframe src="https://open.spotify.com/embed/episode/09VL3oKSyDsdbF0cpGv4b5?utm_source=generator&theme=0" height={'400px'} frameborder="0"></iframe>
                    </div>
                    <div className='col-sm'>
                        <iframe src="https://open.spotify.com/embed/episode/537PEVzMvtdfdtErnQKbE5?utm_source=generator&theme=0" height={'400px'} frameborder="0"></iframe>
                    </div>
                </div>
                <div className='row' style={{ textAlignLast: 'center' }}>
                    <div className='col-sm'>
                        <iframe src="https://open.spotify.com/embed/episode/2DSVXdcJifKRGaid2Ala8K?utm_source=generator&theme=0" height={'400px'} frameborder="0"></iframe>
                    </div>
                    <div className='col-sm'>
                        <iframe src="https://open.spotify.com/embed/episode/6Kyjg3iEGw4oBBZsU3NUB7?utm_source=generator&theme=0" height={'400px'} frameborder="0"></iframe>
                    </div>
                    <div className='col-sm'>
                        <iframe src="https://open.spotify.com/embed/episode/2Zs6AzrbHJCEIHzhPbk97m?utm_source=generator&theme=0" height={'400px'} frameborder="0"></iframe>
                    </div>
                </div>
                <div className='row' style={{ textAlignLast: 'center' }}>
                    <div className='col-sm'>
                        <iframe src="https://open.spotify.com/embed/episode/7jir1GS5xqYp09vfv1xsOA?utm_source=generator&theme=0" height={'400px'} frameborder="0"></iframe>
                    </div>
                    <div className='col-sm'>
                        <iframe src="https://open.spotify.com/embed/episode/6NEPYEBbjv5fRHGfEIKSGK?utm_source=generator&theme=0" height={'400px'} frameborder="0"></iframe>
                    </div>
                    <div className='col-sm'>
                        <iframe src="https://open.spotify.com/embed/episode/0wDuZFyIpKn9SfgAEBMjk1?utm_source=generator&theme=0" height={'400px'} frameborder="0"></iframe>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MyPoadcast
